export const GetDreamRowOpacity = (difficulty: number, isDragging: boolean) => {
    if (isDragging) {
        return 0.5;
    }

    const maximumOpacity = 1.0;
    const lowestDifficulty = 5;
    const reducePerDifficulty = 0.05;
    const reduceBy = (difficulty - lowestDifficulty) * reducePerDifficulty;
    const opacity = maximumOpacity - reduceBy;
    return opacity;
};
